import Lottie from "lottie-react";
import aiLoader from "ui/assets/animations/ai-loader.json";

interface IProps {
  width?: number;
  height?: number;
  animation: "aiLoader";
}

const LottieAnimation = ({ width = 68, height = 40, animation }: IProps) => {
  const getAnimationType = () => {
    switch (animation) {
      case "aiLoader":
        return aiLoader;
      default:
        return aiLoader;
    }
  };

  return (
    <Lottie
      animationData={getAnimationType()}
      loop={true}
      style={{ width, height }}
    />
  );
};

export default LottieAnimation;
